import clsx from "clsx";
import type { ComponentProps } from "react";

import { ArticleCard } from "@entities/article-card";

import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { Heading } from "@shared/ui/typography";

import type { ArticleType } from "@/_pages/article/model";

import s from "./more-articles.module.scss";

export type MoreArticlesProps = ComponentProps<"div"> & {
  className?: string;
  data: ArticleType[];
};

export const MoreArticles = (props: MoreArticlesProps) => {
  const { className, data } = props;

  return (
    <div className={clsx(s.root, className)}>
      <Heading level={3} tag="h2" className={s.title}>
        Похожие новости
      </Heading>
      <div className={s.newCards}>
        {(data ?? []).map((news, idx) =>
          news ? (
            <ArticleCard
              key={news?.documentId ?? news?.hero?.title ?? idx}
              data={news}
              titleTag="h3"
            />
          ) : null,
        )}
      </div>
      <ButtonWithIcon
        iconName="sur"
        iconFillColor="violet"
        variant="primary-dark"
      >
        Смотреть все
      </ButtonWithIcon>
    </div>
  );
};

MoreArticles.displayName = "MoreArticles";
